import serviceTokenNew from '../../services/requestTokenNew';
const API_URL = process.env.REACT_APP_API_URL_DSZ;
const RETAILER_API_URL = process.env.REACT_APP_RETAILER_BASE_API;

/**
 * @description Fetches data within a specified date range and status, with pagination support.
 *
 * @param {string} start_date - The start date for the data range.
 * @param {string} end_date - The end date for the data range.
 * @param {number} limit - The maximum number of items to fetch per page.
 * @param {number} page_no - The page number to retrieve.
 * @param {string} status - The status of the data to fetch.
 * @returns {Promise} - A Promise that resolves to the fetched data.
 *
 * @throws {Error} - Throws an error if the request encounters a problem or returns an error status.
 */
export const getOrderListApi = (params) => {
  return serviceTokenNew({
    // url: `${API_URL}rp/orders/`,
    url: `${RETAILER_API_URL}orders`,
    method: 'get',
    params: params
  });
};

/**
 * @description Get order detail
 *
 * @param {string} order_id - comma separated order_id
 */
export const getOrderDetailApi = (params) => {
  return serviceTokenNew({
    url: `${API_URL}rp/orders/`,
    method: 'get',
    params: { ...params }
  });
};

/**
 * @description Get order detail from retailer-api
 *
 * getOrderDetailApi reaches the same endpoint when `id` is its first query param (see `changeApi` in
 * utils/http.js), so both responses include `gst_excluded`. This one is read as `res.data`, that one as `res.result`.
 *
 * @param {string} id - ruo_id of the order
 */
export const getOrderDetailRetailerApi = (params) => {
  return serviceTokenNew({
    url: `${RETAILER_API_URL}orders`,
    method: 'get',
    params,
  });
};

/**
 * @description Get archive_orders
 * @param page_no
 * @param limit When querying all, set limit:all
 * @param end_date
 */
export const getArchiveOrdersApi = (params) => {
  return serviceTokenNew({
    url: `${API_URL}rp/archive_orders`,
    method: 'get',
    params: params
  });
};

/**
 * @description billing address display
 */
export const getAccountDetailsApi = () => {
  return serviceTokenNew({
    url: `${API_URL}rp/account_details`,
    method: 'get'
  });
};

/**
 * @description cancel order
 */
export const cancelOrderApi = (ids) => {
  const ruoIds = (Array.isArray(ids) ? ids : String(ids).split(',')).map(Number);
  return serviceTokenNew({
    url: `${RETAILER_API_URL}orders/cancel`,
    method: 'put',
    data: { ruoIds }
  });
};

/**
 * @description duplicate order
 * @param {Object} data - { reseller_id: number, ruo_ids: number[] }
 */
export const duplicateOrderApi = (data) => {
  return serviceTokenNew({
    url: `${API_URL}rp/orders/duplicate`,
    method: 'post',
    data: data
  });
};

/**
 * @description Update postage surcharge on an unpaid order
 * @param {number} ruoId - The order ID
 * @param {number} postageSurcharge - The surcharge amount (GST-inclusive)
 */
export const updatePostageSurchargeApi = (ruoId, postageSurcharge) => {
  return serviceTokenNew({
    url: `${RETAILER_API_URL}orders/${ruoId}/surcharge`,
    method: 'patch',
    data: { postageSurcharge }
  });
};

/**
 * @description Per-order surcharge status (single source of truth, retailer-api).
 * @param {(number|string)[]|string} ids - order id(s), array or comma-separated string
 * @returns {Promise} resolves to [{ orderId, surchargeApplicable, surchargeRequired }]
 */
export const getSurchargeStatusApi = (ids) => {
  return serviceTokenNew({
    url: `${RETAILER_API_URL}orders/surcharge-status`,
    method: 'get',
    params: { ids: Array.isArray(ids) ? ids.join(',') : ids }
  });
};